import { TiktokClientPayload } from '@/pages/api/tracking/tiktok/types';

/**
 * Triggers a TikTok conversion event by sending the payload to our server-side API route.
 * This function is safe to use on the client-side as no sensitive data is exposed.
 *
 * @param payload The type-safe event payload.
 */
export const triggerTikTokConversionEvent = async (payload: TiktokClientPayload) => {
	try {
		await fetch('/api/tracking/tiktok', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(payload),
		});
	} catch (error) {
		console.error('Failed to trigger TikTok conversion event:', error);
	}
};
